import { Font } from "../../../../util/config-fonts";

function PgProductCategoryNMerchant({ Category = String, Merchant = String }) {
  return (
    <div className="pgProductDesc">
      {Category === "" ||
      Category === "N/A" ||
      Category.toUpperCase() === "Category".toUpperCase() ? null : (
        <p style={{ color: "black", margin: 0, fontSize: Font.Description }}>
          Category : {Category}
        </p>
      )}
      {Merchant === "" || Merchant === "N/A" ? null : (
        <p
          style={{
            color: "black",
            margin: 0,
            paddingTop: 3,
            fontSize: Font.Description,
          }}
        >
          Merchant : {Merchant}
        </p>
      )}
    </div>
  );
}
export default PgProductCategoryNMerchant;